import * as React from 'react'

const CareersForm = () => <>
  <h2 className="h1 mb-4">Apply now</h2>

  <iframe
    title="Careers inquiry form"
    className="w-full min-h-[768px]"
    src="https://share.hsforms.com/1DmQDobc8SF-g4dBpxeR4bw5grh0"
    frameBorder="0"
 />
</>

export default CareersForm
